// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import Vuex from 'vuex'
import axios from 'axios'
import Notifications from 'vue-notification'
import constPlugin from "./components/constPlugin"
import navigators from "./components/navigators"
import Vuelidate from 'vuelidate'
import Viewer from 'v-viewer'
import VueCollapse from 'vue2-collapse'
import GAuth from 'vue-google-oauth2'
import Autocomplete from '@trevoreyre/autocomplete-vue'
import '@trevoreyre/autocomplete-vue/dist/style.css'
import store from './store'

const gauthOption = {
  clientId: '623995367704-6md9f4i96om29anhfbi6bppebdlagn9b.apps.googleusercontent.com',
  scope: 'profile email',
  prompt: 'select_account'
}

// Loading the plugin into the Vue.
Vue.use(Vuex)
Vue.use(GAuth, gauthOption)
Vue.use(VueCollapse)
Vue.use(constPlugin)
Vue.use(navigators)
// import VueWebsocket from 'vue-websocket'
// Vue.use(VueWebsocket, 'ws://log-staging.asani.co.id:443/',{
//     reconnection: true
// })
Vue.use(Notifications)
Vue.use(Vuelidate)
Vue.use(Viewer)
Vue.use(Autocomplete)

Vue.http = Vue.prototype.$http = axios.create({ timeout: 30000 })
Vue.config.productionTip = false

// import '../node_modules/bootstrap/dist/css/bootstrap.min.css'
/* eslint-disable no-new */
new Vue({
  router,
  store,
  components: { App },
  watch: {
    $route(to, from) {
      if (to !== from) {
        location.reload()
      }
    }
  },
  template: '<App/>'
}).$mount('#app')


// WEBPACK FOOTER //
// ./src/main.js